import api from "../config/api";

export const API_URL_FOR_IMG = 'http://localhost/Projects/uniquejewellers/api/';

export const fetchCategory = async() => {
    const res = await api.get(`/category/`);
    return res.data.data;
}

export const createCategory = async (formData) => {
  const res = await api.post(`/category/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data.data;
}

export const updateCategory = async (id, data)=>{
  const res = await api.post(`/category/?id=${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data.data;
}

export const deleteCategory = async (id)=>{
  const res = await api.delete(`/category/?id=${id}`);
  return res.data.data;
}